import React, {useEffect, useState} from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import {LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer} from 'recharts'
import axios from 'axios'
import moment from 'moment'
import {useReduxAuth} from '../../../auth'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {useMADoctorDropdown} from '../../context/MADoctorDropdownContext'
import {USER_ROLES} from '../../../../constants/StatusConstants'

// Define the shape of your data
interface DataPoint {
  day: string // "YYYY-MM-DD"
  count: number // patient count
}

const RPMReadingsTrend: React.FC = () => {
  const {currentUser} = useReduxAuth()
  const maDropdown = useMADoctorDropdown()
  const maSelectedDoctorId = currentUser?.role_id === USER_ROLES.MEDICAL_ASSISTANT ? maDropdown.selectedDoctorId : undefined
  
  const [trendData, setTrendData] = useState<DataPoint[]>([])

  useEffect(() => {
    const fetchPatients = async () => {
      // Skip if MA and no doctor selected
      if (currentUser?.role_id === USER_ROLES.MEDICAL_ASSISTANT && !maSelectedDoctorId) {
        setTrendData([])
        return
      }

      try {
        // Build query params for MA
        const queryParams = new URLSearchParams()
        if (currentUser?.role_id === USER_ROLES.MEDICAL_ASSISTANT && maSelectedDoctorId) {
          queryParams.append('doctor_id', maSelectedDoctorId.toString())
        }

        const response = await axios.get(
          API_ENDPOINTS.GET_RPM_READINGS_TREND(queryParams.toString())
        )
        const data: DataPoint[] = response.data.data ?? []
        setTrendData(data)
      } catch (error) {}
    }
    if (currentUser?.id || (currentUser?.role_id === USER_ROLES.MEDICAL_ASSISTANT && maSelectedDoctorId)) {
      fetchPatients()
    }
  }, [currentUser, maSelectedDoctorId])

  // Show every tick or filter to taste
  const xAxisTicks = trendData.map((d) => d.day)

  return (
    <div className='p-4 bg-white rounded-4 shadow-sm border w-100 h-100'>
      <div className='d-flex align-items-center gap-2'>
        <h3>Readings Trend</h3>
        <span className='text-muted'>(Last 30 Days)</span>
      </div>
      <ResponsiveContainer width='100%' height={363}>
        <LineChart
          data={trendData}
          margin={{
            top: 20,
            right: 20,
            left: 0, // extra space for Y label
            bottom: 0, // room for rotated X labels
          }}
        >
          <XAxis
            dataKey='day'
            ticks={xAxisTicks}
            tickFormatter={(value: string) => moment(value, 'YYYY-MM-DD').format('MMM DD')}
            angle={-45}
            textAnchor='end'
            height={50}
          />

          <YAxis
            domain={[0, Math.max(...trendData.map((d) => d.count), 0) + 5]}
            label={{
              value: 'Patients with Reading (99445/99454)',
              angle: -90,
              position: 'left',
              dx: 20, // move it further left
              dy: -100,
            }}
          />

          <Tooltip labelFormatter={(label) => moment(label, 'YYYY-MM-DD').format('MMMM D, YYYY')} />
          <Legend verticalAlign='top' />
          <Line
            type='monotone'
            dataKey='count'
            stroke='#8884d8'
            // activeDot={{r: 8}}
            name='Patients with Reading (≥1/day)'
            strokeWidth={2} // <-- line thickness
            dot={{r: 3}}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}

export default RPMReadingsTrend
